import {
  Activity,
  Bell,
  Compass,
  FilePenLine,
  Flag,
  FolderKanban,
  FolderOpen,
  Grid2X2,
  ListChecks,
  MessageCircle,
  Monitor,
  Settings2,
  Terminal,
  Users,
} from "lucide-react";

const icons = {
  missions: Flag,
  tasks: ListChecks,
  projects: FolderKanban,
  messages: MessageCircle,
  activity: Activity,
  notifications: Bell,
  briefing: Compass,
  files: FolderOpen,
  editor: FilePenLine,
  computers: Monitor,
  system: Settings2,
  apps: Grid2X2,
  terminal: Terminal,
  "shared-bots": Users,
};
export function WorkspaceAppIcon({
  id,
  small = false,
  compact = false,
}: {
  id: string;
  small?: boolean;
  compact?: boolean;
}) {
  const Icon = icons[id as keyof typeof icons] ?? Grid2X2;
  return (
    <span
      className={`workspace-app-icon${compact ? " workspace-app-icon-compact" : small ? " workspace-app-icon-small" : ""}`}
      aria-hidden="true"
    >
      <Icon size={compact ? 16 : small ? 22 : 29} strokeWidth={1.45} />
    </span>
  );
}
